/* global window */

import log from 'loglevel';
import sha256 from 'tiny-sha256';

import Sailthru from './Sailthru';
import Braze from './Braze';
import PIP from './PIP';
import MediaOS from './MediaOS';

/**
 * Sync user ID before starting a Braze session.
 * @param {Sailthru} sailthru - Sailthru instance.
 * @param {Braze} braze - Braze instance.
 * @param {PIP} pip - PIP instance.
 */
function syncUserVeryLocal(sailthru, braze, pip) {
  if (!sailthru.isSailthruReady || !braze.isBrazeReady) {
    return;
  }

  sailthru.fetchCurrentUserData()
    .then(() => braze.changeUser(sailthru.userEmailHash))
    .then(() => braze.fetchCurrentUserData())
    .then(() => braze.openSession())
    .then(() => pip.getUserLocationPermissionStatus())
    .then(() => pip.getUserLocation())
    .then(() => pip.getUserNeighborhoods())
    .then(() => braze.setLastKnownLocation(pip.location, pip.neighborhoods))
    .then(() => braze.pushRequest())
    .catch(error => log.error(error));
}

/**
 * Sync user ID before starting a Braze session.
 * @param {Sailthru} sailthru - Sailthru instance.
 * @param {Braze} braze - Braze instance.
 * @param {PIP} pip - PIP instance.
 */
function syncUserMediaOS(sailthru, braze, pip) {
  if (!sailthru.isSailthruReady || !braze.isBrazeReady) {
    return;
  }

  sailthru.fetchCurrentUserData()
    .then(() => braze.changeUser(sailthru.userEmailHash))
    .then(() => braze.fetchCurrentUserData())
    .then(() => braze.openSession())
    .then(() => pip.getUserLocationPermissionStatus())
    .then(() => pip.getUserLocation())
    .then(() => pip.getUserNeighborhoods())
    .then(() => braze.setLastKnownLocation(pip.location, pip.neighborhoods))
    .then(() => MediaOS.updateWeather(pip.location))
    .then(() => braze.pushRequest())
    .catch(error => log.error(error));
}

/**
 * Basic user signup flow: subscribe the email to the Sailthru list
 * and change the Braze user id to the email hash.
 * @param {Sailthru} sailthru - Sailthru instance.
 * @param {Braze} braze - Braze instance.
 * @param {string} email - User email.
 * @param {string} list - Sailthru email list.
 * @param {string} source - Sailthru subscription source.
 * @param {Object} vars - Sailthru signup variables.
 * @returns {Promise}
 */
function userSignUp(sailthru, braze, email, list, source, vars = {}) {
  const lists = {};
  lists[list] = 1;

  return Promise.all([
    sailthru.userSignUp(email, lists, source, vars),
    braze.changeUser(sha256(email)),
  ]);
}

/**
 * Load and initialize required scripts.
 */
function bootstrap() {
  const sailthru = new Sailthru();
  const braze = new Braze();
  const pip = new PIP();
  const components = [sailthru, braze, pip];

  if (window.METAPHOR_DISABLED) {
    return;
  }

  Promise.all(components.map(component => component.load()))
    .then(() => {
      components.map(component => component.init());

      if (window.VLCL) {
        syncUserVeryLocal(sailthru, braze, pip);
      }

      if (window.HRST) {
        syncUserMediaOS(sailthru, braze, pip);
      }

      window.Metaphor = window.Metaphor || {};
      window.Metaphor.signUp = userSignUp.bind(this, sailthru, braze);
    })
    .catch(error => log.error(error));
}

export default bootstrap;



// WEBPACK FOOTER //
// ./src/bootstrap.js